import { render, staticRenderFns } from "./ErrorBanner.vue?vue&type=template&id=16778738&scoped=true&"
import script from "./ErrorBanner.vue?vue&type=script&lang=ts&"
export * from "./ErrorBanner.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorBanner.vue?vue&type=style&index=0&id=16778738&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16778738",
  null
  
)

export default component.exports